import type NotificationViewState from '../store/schema/NotificationViewState';
import { mutatorAction } from 'satcheljs';
import store from '../store/store';

let nextId = 0;

export default mutatorAction(
    'addNotification',
    function addNotification(notificationViewState: NotificationViewState) {
        let notification = {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2783 (14,13): 'id' is specified more than once, so this usage will be overwritten.
            // @ts-expect-error
            id: nextId++,
            ...notificationViewState,
        };
        store.notificationViewStates.push(notification);
    }
);
